export default __webpack_public_path__ + "static/section-services-2-7a8645e559124c096b1c2d576209c43c.jpg";